import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom';
import GA from './GA';

const wrapAsyncImport = (module) => (
  class wrapAsyncImport extends Component {
    state = {
      isLoaded: false,
      isErrored: false,
      AsyncComponent: null
    };

    constructor(props) {
      super(props);
      (typeof module === 'function' ? module() : module).then((component) => this.componentLoaded(component))
      .catch((error) => this.componentErrored(error));
    }

    componentLoaded(component) {
      this.setState({
        AsyncComponent: component.default,
        isLoaded: true
      });
    }

    componentErrored(error) {
      console.error(error);
      this.setState({
        isErrored: true,
        isLoaded: true
      });
    }

    render() {
      const {
        isErrored
      } = this.state;

      if (isErrored) {
        return (
          <h1>ページの読み込みに失敗しました。</h1>
        );
      } else {
        const {
          AsyncComponent,
          isLoaded
        } = this.state;

        return (
          <div className={isLoaded ? 'router loaded' : 'router loading'}>
            {
              isLoaded ? (
                <AsyncComponent { ...this.props } />
              ) : null
            }
          </div>
        );
      }
    }
  }
);

class ScrollToTop extends Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop = withRouter(ScrollToTop);

class Tracker extends Component {
  componentDidUpdate(props) {
    console.log(props)
  }

  render() {
    return null;
  }
}

class App extends Component {
  

  render() {
    //const supportsHistory = 'pushState' in window.history;
    return (
      <BrowserRouter basename={'/hakuensai2018'}>
        <ScrollToTop>
          <Switch>
            <Route exact path={'/'} component={wrapAsyncImport(import('./components/Home'))} />
            <Route exact path={'/category/event.html'} component={wrapAsyncImport(() => import('./components/EventSchedule'))} />
            <Route exact path={'/category/stage.html'} component={wrapAsyncImport(() => import('./components/StageSchedule'))} />
            <Route exact path={'/category/after-fes.html'} component={wrapAsyncImport(() => import('./components/ComingSoon'))} />
            <Route exact path={'/category/:category.html'} component={require('./components/Category').default} />
            <Route exact path={'/detail/:category/:name.html'} component={wrapAsyncImport(() => import('./components/RoomDetail'))} />
            {
              /*<Route path={'/about.html'} component={wrapAsyncImport(() => import('./components/About'))} />*/
            }
            <Route path={'/favorites.html'} component={wrapAsyncImport(() => import('./components/FavoriteList'))} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js